<template>
    <div class="envelope-list">
        <envelope-list-item
            v-for="envelope in envelopes"
            :key="envelope.id"
            :envelope="envelope"
        />
    </div>
</template>

<script>
import EnvelopeListItem from './envelope-list-item.vue';

export default {
    components: {
        EnvelopeListItem,
    },

    props: {
        envelopes: {},
    },
}
</script>

<style scoped>
.envelope-list { max-height: 24rem; overflow-y: auto; overscroll-behavior: contain; }
</style>
